// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3nbqr","box":"WorkspacesBox_box__39fM4","node":"WorkspacesBox_node__1jfxv"};